import i from "./extends3.mjs";
import { singleItemValueManager as m, singleItemFieldValueManager as n } from "./valueManagers.mjs";
import { validateDate as u } from "./validateDate.mjs";
import { applyDefaultDate as o } from "./date-utils.mjs";
import { useUtils as d, useDefaultDates as f } from "./useUtils.mjs";
import { splitFieldInternalAndForwardedProps as D } from "./fields.mjs";
import { useField as p } from "./useField.mjs";
const F = (e) => {
  var t, r, l;
  const a = d(), s = f();
  return i({}, e, {
    disablePast: (t = e.disablePast) != null ? t : !1,
    disableFuture: (r = e.disableFuture) != null ? r : !1,
    format: (l = e.format) != null ? l : a.formats.keyboardDate,
    minDate: o(a, e.minDate, s.minDate),
    maxDate: o(a, e.maxDate, s.maxDate)
  });
}, _ = ({
  props: e,
  inputRef: t
}) => {
  const r = F(e), {
    forwardedProps: l,
    internalProps: a
  } = D(r, "date");
  return p({
    inputRef: t,
    forwardedProps: l,
    internalProps: a,
    valueManager: m,
    fieldValueManager: n,
    validator: u,
    valueType: "date"
  });
};
export {
  _ as useDateField
};
//# sourceMappingURL=useDateField.mjs.map
